import { render } from "./FeaturedResultsDialog.vue?vue&type=template&id=48b13308"
import script from "./FeaturedResultsDialog.vue?vue&type=script&lang=js"
export * from "./FeaturedResultsDialog.vue?vue&type=script&lang=js"

import "./FeaturedResultsDialog.vue?vue&type=style&index=0&id=48b13308&lang=scss"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__